import { render, staticRenderFns } from "./SampleActivities.vue?vue&type=template&id=178e48bc"
import script from "./SampleActivities.vue?vue&type=script&lang=js"
export * from "./SampleActivities.vue?vue&type=script&lang=js"
import style0 from "./SampleActivities.vue?vue&type=style&index=0&id=178e48bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports